<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>入金通知報告情報</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div [formGroupName]="isEdit? 'updateInfo' :'reginf'">
            <div class=" tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center
            tw-content-center">
                <mat-form-field [appearance]="getAppearance('companycode')"
                    class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>会社</mat-label>
                    <mat-select formControlName="companycode" class="disabled-select-color">
                        <mat-option *ngFor="let type of companyList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [appearance]="getAppearance('rcvmnyAreacode')"
                    class="input-form-date tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>入金地区</mat-label>
                    <mat-select formControlName="rcvmnyAreacode" class="disabled-select-color">
                        <mat-option *ngFor="let type of rcvmnyAreaList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="getAppearance('kouzaRcvmnyYearmonthdate')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>口座入金年月日</mat-label>
                    <input matInput [matDatepicker]="kouzaRcvmnyYearmonthdate"
                        formControlName="kouzaRcvmnyYearmonthdate" class="font-color-display-only" required
                        autocomplete="off" maxlength="10">
                    <mat-datepicker-toggle matSuffix [for]="kouzaRcvmnyYearmonthdate"
                        *ngIf="!isEdit"></mat-datepicker-toggle>
                    <mat-datepicker #kouzaRcvmnyYearmonthdate></mat-datepicker>
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="getAppearance('rcvmnyKouzacode')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[50%] w-full md:w-auto">
                    <mat-label>入金口座</mat-label>
                    <mat-select formControlName="rcvmnyKouzacode" class="disabled-select-color">
                        <mat-option *ngFor="let type of rcvmnyKouzaList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <mat-form-field [appearance]="getAppearance('rcvmnyKeitaiCode')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>入金形態</mat-label>
                    <mat-select formControlName="rcvmnyKeitaiCode" required (selectionChange)="onChangeRcvmnyKeitai()"
                        class="disabled-select-color">
                        <mat-option *ngFor="let type of rcvmnyKeitaiList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field [appearance]="isMordal ? getAppearance('kouzaRcvmnyBankofficecode'): 'outline'"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>口座入金機関</mat-label>
                    <mat-select formControlName="kouzaRcvmnyBankofficecode" required class="disabled-select-color">
                        <mat-option *ngFor="let type of kouzaRcvmnyFcltList" [value]="type.value">{{type.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                *ngIf="!isEdit">
                <mat-form-field appearance="outline"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>口座入金額</mat-label>
                    <input numberInput min=0 max=999999999999 maxlength=12 matInput formControlName="kouzaRcvmnyAmt"
                        required class="text-right" autocomplete="off">
                    <span matSuffix class="font-color-display-only">円</span>
                </mat-form-field>
            </div>
            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                *ngIf="isEdit">
                <mat-form-field [appearance]="getAppearance('befteiseiInmny')"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>訂正前入金額</mat-label>
                    <input numberInput min=0 max=999999999999 maxlength=12 matInput formControlName="befteiseiInmny"
                        class="font-color-display-only text-right">
                    <span matSuffix class="font-color-display-only">円</span>
                </mat-form-field>
            </div>
            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                *ngIf="isEdit">
                <div
                    class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <p class="tw-ml-[45px]">▼</p>
                </div>
            </div>
            <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center"
                *ngIf="isEdit">
                <mat-form-field appearance="outline"
                    class="input-form-select tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[30%] w-full md:w-auto">
                    <mat-label>訂正後入金額</mat-label>
                    <input numberInput min=0 max=999999999999 maxlength=12 matInput formControlName="afteiseiInmny"
                        required class="text-right" autocomplete="off" [ngStyle]="afteiseiInmnyStyle"
                        (input)="onChangeAfteiseiInmny()">
                    <span matSuffix class="font-color-display-only">円</span>
                </mat-form-field>
            </div>
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center">
                <mat-card-actions class="btn_area_right">
                    <button type="submit" [disabled]="rcvmnyRegInfDto.invalid" mat-raised-button color="primary"
                        class="btn" *ngIf="!isMordal">登録</button>
                    <button type="button" (click)="onClickCancel()" mat-raised-button color="primary"
                        class="btn" *ngIf="isMordal">キャンセル</button>
                    <button type="submit"
                        [disabled]="rcvmnyRegInfDto.invalid" mat-raised-button color="primary" class="btn"
                        *ngIf="isMordal && !isEdit">登録</button>
                    <button type="submit"
                        [disabled]="rcvmnyRegInfDto.invalid" mat-raised-button color="primary" class="btn"
                        *ngIf="isMordal && isEdit">登録</button>
                    <button type="button" (click)="onClickRemove()"
                        mat-raised-button color="primary" class="btn" *ngIf="isMordal && isEdit">削除</button>
                </mat-card-actions>
            </div>
        </div>
    </mat-card-content>
</mat-card>